var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAIChat)?_c('div',{attrs:{"data-airops-widget":"36faca9b-4fa4-4c98-877f-225e9488abea","data-airops-init":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }